import { render, staticRenderFns } from "./JsonPage.vue?vue&type=template&id=0a5fefd5&lang=pug"
import script from "./JsonPage.vue?vue&type=script&lang=js"
export * from "./JsonPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoverlyHomeHero: require('/app/components/pages/home/HomeHero.vue').default,LoverlyHeading: require('/app/components/elements/typography/Heading.vue').default,LoverlyLogo: require('/app/components/elements/Logo.vue').default,LoverlyJsonForm: require('/app/components/forms/JsonForm.vue').default,LoverlyJsonContactForm: require('/app/components/forms/JsonContactForm.vue').default,LoverlyListContentRenderer: require('/app/components/list/ListContentRenderer.vue').default,LoverlySeoBlock: require('/app/components/blocks/SeoBlock.vue').default,LoverlySeoPageList: require('/app/components/blocks/SeoPageList.vue').default})
